import React, { useState, useRef, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, onSnapshot, query, orderBy, where, getDocs, serverTimestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAbmt0vLEX8vS05SHpYWt4tZYQezd0X1XY",
  authDomain: "ara-hauling-dispatching.firebaseapp.com",
  projectId: "ara-hauling-dispatching",
  storageBucket: "ara-hauling-dispatching.firebasestorage.app",
  messagingSenderId: "234204409923",
  appId: "1:234204409923:web:8c8a0137e1865eba4ea4f6",
  measurementId: "G-3NCC4E2DZW"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

var T = {
  en: {
    appName:"ARA Hauling Dispatching",signIn:"Sign in to your account",username:"EMAIL",password:"PASSWORD",
    enterUser:"Enter your email",enterPass:"Enter your password",signInBtn:"Sign In",
    incorrectLogin:"Incorrect email or password. Please try again.",
    dispatcher:"Dispatcher",driver:"Driver",logout:"Logout",
    dashboard:"Dashboard",jobs:"Jobs",drivers:"Drivers",messages:"Messages",broadcast:"Broadcast",
    myJobs:"My Jobs",chat:"Chat",
    totalJobs:"Total Jobs Today",activeJobs:"Active Jobs",delivered:"Delivered",availableDrivers:"Available Drivers",
    recentJobs:"Recent Jobs",allJobs:"All Jobs",newJob:"+ New Job",createJob:"Create New Job",
    jobTitle:"Job Title *",pickupAddr:"Pickup Address *",deliveryAddr:"Delivery Address *",
    notes:"Notes",priority:"Priority",assignDriver:"Assign Driver",unassigned:"Unassigned",
    createJobBtn:"Create Job",cancel:"Cancel",viewRoute:"View Route",fillRequired:"Please fill in required fields.",
    jobCreated:"Job created successfully!",statusUpdated:"Status updated to: ",markedDelivered:"Job marked as Delivered! ✅",
    driverOverview:"Driver Overview",lastKnown:"Last known:",activeJob:"Active Job:",message:"Message",
    noMessagesYet:"No messages yet",sendHi:"No messages yet. Say hi!",
    broadcastTitle:"Broadcast Message",broadcastSubtitle:"Send a message to all drivers at once. Drivers cannot reply to broadcasts.",
    willReceive:"drivers will receive this message",broadcastPlaceholder:"Type your broadcast message...",
    sendAll:"Send to All Drivers",broadcastHistory:"Broadcast History",allDrivers:"All Drivers",
    broadcastSent:"📣 Broadcast sent to all ",broadcastSentEnd:" drivers!",
    dispatchBroadcast:"DISPATCH BROADCAST",latestBroadcast:"LATEST BROADCAST",
    noJobsYet:"No jobs assigned yet.",checkBack:"Check back soon or contact dispatch.",
    pickup:"Pickup",delivery:"Delivery",openRoute:"Open Route in Google Maps",
    updateStatus:"Update your status:",inTransit:"In Transit",pickedUp:"Picked Up",jobComplete:"Job Complete!",
    chatTitle:"Chat with Dispatch",chatPrivate:"Messages are private between you and your dispatcher.",
    messageDispatch:"Message dispatch...",typeMessage:"Type a message...",send:"Send",back:"← Back",
    available:"Available",onJob:"On Job",offDuty:"Off Duty",
    high:"High",normal:"Normal",low:"Low",
    activeJobsLabel:" active jobs · ",driversAvail:" drivers available",
    translating:"Translating...",translate:"Translate",showOriginal:"Show original",
    pending:"Pending",assigned:"Assigned",statusDelivered:"Delivered",loading:"Loading..."
  },
  es: {
    appName:"ARA Hauling Dispatching",signIn:"Inicia sesión en tu cuenta",username:"CORREO",password:"CONTRASEÑA",
    enterUser:"Ingresa tu correo",enterPass:"Ingresa tu contraseña",signInBtn:"Iniciar Sesión",
    incorrectLogin:"Correo o contraseña incorrectos. Intenta de nuevo.",
    dispatcher:"Despachador",driver:"Conductor",logout:"Salir",
    dashboard:"Inicio",jobs:"Trabajos",drivers:"Conductores",messages:"Mensajes",broadcast:"Difusión",
    myJobs:"Mis Trabajos",chat:"Chat",
    totalJobs:"Trabajos de Hoy",activeJobs:"Trabajos Activos",delivered:"Entregados",availableDrivers:"Conductores Disponibles",
    recentJobs:"Trabajos Recientes",allJobs:"Todos los Trabajos",newJob:"+ Nuevo Trabajo",createJob:"Crear Nuevo Trabajo",
    jobTitle:"Título del Trabajo *",pickupAddr:"Dirección de Recogida *",deliveryAddr:"Dirección de Entrega *",
    notes:"Notas",priority:"Prioridad",assignDriver:"Asignar Conductor",unassigned:"Sin Asignar",
    createJobBtn:"Crear Trabajo",cancel:"Cancelar",viewRoute:"Ver Ruta",fillRequired:"Por favor completa los campos requeridos.",
    jobCreated:"¡Trabajo creado exitosamente!",statusUpdated:"Estado actualizado a: ",markedDelivered:"¡Trabajo marcado como Entregado! ✅",
    driverOverview:"Vista de Conductores",lastKnown:"Última ubicación:",activeJob:"Trabajo Activo:",message:"Mensaje",
    noMessagesYet:"Sin mensajes aún",sendHi:"Sin mensajes aún. ¡Di hola!",
    broadcastTitle:"Mensaje de Difusión",broadcastSubtitle:"Envía un mensaje a todos los conductores. Los conductores no pueden responder.",
    willReceive:"conductores recibirán este mensaje",broadcastPlaceholder:"Escribe tu mensaje de difusión...",
    sendAll:"Enviar a Todos los Conductores",broadcastHistory:"Historial de Difusión",allDrivers:"Todos los Conductores",
    broadcastSent:"📣 Difusión enviada a ",broadcastSentEnd:" conductores!",
    dispatchBroadcast:"DIFUSIÓN DE DESPACHO",latestBroadcast:"ÚLTIMA DIFUSIÓN",
    noJobsYet:"No tienes trabajos asignados aún.",checkBack:"Revisa pronto o contacta al despacho.",
    pickup:"Recogida",delivery:"Entrega",openRoute:"Abrir Ruta en Google Maps",
    updateStatus:"Actualiza tu estado:",inTransit:"En Camino",pickedUp:"Recogido",jobComplete:"¡Trabajo Completado!",
    chatTitle:"Chat con Despacho",chatPrivate:"Los mensajes son privados entre tú y tu despachador.",
    messageDispatch:"Mensaje al despacho...",typeMessage:"Escribe un mensaje...",send:"Enviar",back:"← Atrás",
    available:"Disponible",onJob:"En Trabajo",offDuty:"Fuera de Turno",
    high:"Alta",normal:"Normal",low:"Baja",
    activeJobsLabel:" trabajos activos · ",driversAvail:" conductores disponibles",
    translating:"Traduciendo...",translate:"Traducir",showOriginal:"Ver original",
    pending:"Pendiente",assigned:"Asignado",statusDelivered:"Entregado",loading:"Cargando..."
  }
};

var STATUS_COLORS = {"Available":"#22c55e","On Job":"#f59e0b","Off Duty":"#6b7280","Assigned":"#3b82f6","In Transit":"#f59e0b","Picked Up":"#8b5cf6","Delivered":"#22c55e","Pending":"#6b7280"};
var PRI_COLORS = {"High":"#ef4444","Normal":"#3b82f6","Low":"#6b7280"};

function translateText(text, callback) {
  fetch("https://api.anthropic.com/v1/messages", {
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify({
      model:"claude-sonnet-4-6",
      max_tokens:300,
      messages:[{role:"user",content:"Translate the following text to both English and Spanish. Return ONLY a valid JSON object with keys 'en' and 'es', no markdown, no explanation:\n\n"+text}]
    })
  }).then(function(r){return r.json();}).then(function(data){
    var raw=data.content[0].text.replace(/```json|```/g,"").trim();
    callback(null,JSON.parse(raw));
  }).catch(function(err){callback(err,null);});
}

function Badge(props) {
  return React.createElement("span",{style:{background:props.color+"22",color:props.color,border:"1px solid "+props.color+"44",borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:600}},props.label);
}

function LangToggle(props) {
  return React.createElement("button",{onClick:function(){props.setLang(props.lang==="en"?"es":"en");},style:{background:"#334155",border:"1px solid #475569",color:"white",borderRadius:8,padding:"5px 12px",fontSize:12,cursor:"pointer",fontWeight:700}},props.lang==="en"?"🇲🇽 Español":"🇺🇸 English");
}

function ChatMessage(props) {
  var m=props.m; var isSelf=props.isSelf; var lang=props.lang;
  var st=useState(false); var showing=st[0]; var setShowing=st[1];
  var displayText=showing&&m.translated?m.translated[lang]:m.text;
  var hasTranslation=m.translated&&m.translated[lang]&&m.translated[lang]!==m.text;
  var t=T[lang];
  return React.createElement("div",{style:{display:"flex",justifyContent:isSelf?"flex-end":"flex-start",marginBottom:8}},
    React.createElement("div",{style:{maxWidth:"75%"}},
      React.createElement("div",{style:{background:isSelf?"#f59e0b":"#334155",color:isSelf?"#0f172a":"white",borderRadius:12,padding:"8px 14px",fontSize:13}},
        React.createElement("div",null,displayText),
        React.createElement("div",{style:{fontSize:10,color:isSelf?"#78350f":"#94a3b8",marginTop:4}},m.time)
      ),
      m.translating?React.createElement("div",{style:{fontSize:10,color:"#64748b",marginTop:3,textAlign:isSelf?"right":"left"}},"🌐 "+t.translating):
      hasTranslation?React.createElement("button",{onClick:function(){setShowing(!showing);},style:{background:"none",border:"none",color:"#64748b",fontSize:10,cursor:"pointer",marginTop:2,padding:0,display:"block",textAlign:isSelf?"right":"left",width:"100%"}},"🌐 "+(showing?t.showOriginal:t.translate)):null
    )
  );
}

export default function App() {
  var langSt=useState("en"); var lang=langSt[0]; var setLang=langSt[1];
  var t=T[lang];
  var userSt=useState(null); var currentUser=userSt[0]; var setCurrentUser=userSt[1];
  var formSt=useState({username:"",password:""}); var loginForm=formSt[0]; var setLoginForm=formSt[1];
  var errSt=useState(""); var loginError=errSt[0]; var setLoginError=errSt[1];
  var passSt=useState(false); var showPassword=passSt[0]; var setShowPassword=passSt[1];
  var driversSt=useState([]); var drivers=driversSt[0]; var setDrivers=driversSt[1];
  var jobsSt=useState([]); var jobs=jobsSt[0]; var setJobs=jobsSt[1];
  var msgsSt=useState({}); var messages=msgsSt[0]; var setMessages=msgsSt[1];
  var tabSt=useState("dashboard"); var activeTab=tabSt[0]; var setActiveTab=tabSt[1];
  var jobFormSt=useState(false); var showJobForm=jobFormSt[0]; var setShowJobForm=jobFormSt[1];
  var chatSt=useState(null); var chatWith=chatSt[0]; var setChatWith=chatSt[1];
  var inputSt=useState(""); var msgInput=inputSt[0]; var setMsgInput=inputSt[1];
  var newJobSt=useState({title:"",pickup:"",delivery:"",notes:"",priority:"Normal",driverId:""}); var newJob=newJobSt[0]; var setNewJob=newJobSt[1];
  var notifSt=useState(null); var notification=notifSt[0]; var setNotification=notifSt[1];
  var loadingSt=useState(false); var loading=loadingSt[0]; var setLoading=loadingSt[1];
  var chatEndRef=useRef(null);

  // Load drivers from Firestore
  useEffect(function() {
    if (!currentUser) return;
    var q=query(collection(db,"users"),where("role","==","driver"));
    var unsub=onSnapshot(q,function(snap) {
      var list=[];
      snap.forEach(function(d) { list.push(Object.assign({},d.data(),{uid:d.id})); });
      setDrivers(list);
    });
    return unsub;
  },[currentUser]);

  // Load jobs from Firestore
  useEffect(function() {
    if (!currentUser) return;
    var q=query(collection(db,"jobs"),orderBy("createdAt","desc"));
    var unsub=onSnapshot(q,function(snap) {
      var list=[];
      snap.forEach(function(d) { list.push(Object.assign({},d.data(),{id:d.id})); });
      setJobs(list);
    });
    return unsub;
  },[currentUser]);

  // Load messages from Firestore
  useEffect(function() {
    if (!currentUser) return;
    var key=currentUser.role==="dispatcher"?(chatWith?"driver-"+chatWith:""):("driver-"+currentUser.uid);
    if (!key) return;
    var q=query(collection(db,"messages-"+key),orderBy("createdAt","asc"));
    var unsub=onSnapshot(q,function(snap) {
      var list=[];
      snap.forEach(function(d) { list.push(Object.assign({},d.data(),{id:d.id})); });
      setMessages(function(prev) { var u=Object.assign({},prev); u[key]=list; return u; });
    });
    return unsub;
  },[currentUser,chatWith]);

  // Load broadcasts
  useEffect(function() {
    if (!currentUser) return;
    var q=query(collection(db,"broadcasts"),orderBy("createdAt","desc"));
    var unsub=onSnapshot(q,function(snap) {
      var list=[];
      snap.forEach(function(d) { list.push(Object.assign({},d.data(),{id:d.id})); });
      setMessages(function(prev) { var u=Object.assign({},prev); u["broadcast"]=list; return u; });
    });
    return unsub;
  },[currentUser]);

  function notify(msg,type) {
    setNotification({msg:msg,type:type||"success"});
    setTimeout(function(){setNotification(null);},3000);
  }

  function handleLogin() {
    setLoginError(""); setLoading(true);
    signInWithEmailAndPassword(auth,loginForm.username.trim(),loginForm.password)
      .then(function(cred) {
        var uid=cred.user.uid;
        getDocs(query(collection(db,"users"),where("email","==",loginForm.username.trim().toLowerCase())))
          .then(function(snap) {
            setLoading(false);
            if (!snap.empty) {
              var data=snap.docs[0].data();
              var role=data.role?data.role.toLowerCase():"driver";
              setCurrentUser({uid:uid,email:loginForm.username,role:role,name:data.name,driverId:snap.docs[0].id});
              setActiveTab(role==="dispatcher"?"dashboard":"jobs");
            } else {
              setLoginError("Account found but no role assigned. Contact your administrator.");
            }
          });
      })
      .catch(function() { setLoading(false); setLoginError(t.incorrectLogin); });
  }

  function handleLogout() {
    signOut(auth).then(function() {
      setCurrentUser(null); setLoginForm({username:"",password:""}); setLoginError(""); setActiveTab("dashboard"); setChatWith(null);
    });
  }

  function sendMessage(fromRole,toDriverId,text) {
    if (!text.trim()) return;
    var key="driver-"+toDriverId;
    var msgData={from:fromRole,text:text,time:new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}),createdAt:serverTimestamp(),translating:true,translated:null};
    addDoc(collection(db,"messages-"+key),msgData).then(function(ref) {
      translateText(text,function(err,parsed) {
        updateDoc(doc(db,"messages-"+key,ref.id),{translating:false,translated:err?null:parsed});
      });
    });
    setMsgInput("");
  }

  function createJob() {
    if (!newJob.title||!newJob.pickup||!newJob.delivery) { notify(t.fillRequired,"error"); return; }
    var driverDoc=newJob.driverId?drivers.find(function(d){return d.uid===newJob.driverId;}):null;
    var job={
      title:newJob.title,pickup:newJob.pickup,delivery:newJob.delivery,notes:newJob.notes,priority:newJob.priority,
      status:newJob.driverId?"Assigned":"Pending",
      driverId:newJob.driverId||null,
      driverName:driverDoc?driverDoc.name:t.unassigned,
      createdAt:serverTimestamp(),
      createdAtDisplay:new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})
    };
    addDoc(collection(db,"jobs"),job).then(function() {
      setNewJob({title:"",pickup:"",delivery:"",notes:"",priority:"Normal",driverId:""});
      setShowJobForm(false);
      notify(t.jobCreated);
    });
  }

  function updateJobStatus(jobId,newStatus) {
    updateDoc(doc(db,"jobs",jobId),{status:newStatus}).then(function() {
      if (newStatus==="Delivered") notify(t.markedDelivered);
      else notify(t.statusUpdated+newStatus);
    });
  }

  function getDriverJobs(driverUid) { return jobs.filter(function(j){return j.driverId===driverUid;}); }
  function getDriverName(uid) { var d=drivers.find(function(d){return d.uid===uid;}); return d?d.name:t.unassigned; }
  function gmapsRoute(p,d) { return "https://www.google.com/maps/dir/"+encodeURIComponent(p)+"/"+encodeURIComponent(d); }
  function statusLabel(s) { return s==="Available"?t.available:s==="On Job"?t.onJob:t.offDuty; }
  function priLabel(p) { return p==="High"?t.high:p==="Normal"?t.normal:t.low; }

  var pageStyle={fontFamily:"system-ui,sans-serif",minHeight:"100vh",background:"#0f172a",color:"white"};

  function NotifBar() {
    if (!notification) return null;
    var color=notification.type==="error"?"#ef4444":"#22c55e";
    return React.createElement("div",{style:{background:color+"22",border:"1px solid "+color,color:color,padding:"10px 16px",fontSize:13,margin:"8px 16px",borderRadius:8}},notification.msg);
  }

  function NavBar(props) {
    return React.createElement("div",{style:{background:"#1e293b",padding:"0 16px",display:"flex",gap:4,overflowX:"auto"}},
      props.tabs.map(function(tab) {
        return React.createElement("button",{key:tab.id,onClick:function(){setActiveTab(tab.id);setChatWith(null);},style:{padding:"12px 16px",border:"none",background:"none",color:activeTab===tab.id?"#f59e0b":"#94a3b8",fontWeight:activeTab===tab.id?700:400,fontSize:13,cursor:"pointer",borderBottom:activeTab===tab.id?"2px solid #f59e0b":"2px solid transparent",whiteSpace:"nowrap"}},tab.icon+" "+tab.label);
      })
    );
  }

  function AppHeader(props) {
    return React.createElement("div",{style:{background:"linear-gradient(90deg,#1e3a5f,#0f172a)",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center"}},
      React.createElement("div",null,
        React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8}},React.createElement("span",{style:{fontSize:20}},"🚛"),React.createElement("span",{style:{color:"white",fontWeight:800,fontSize:16}},t.appName)),
        props.subtitle?React.createElement("div",{style:{color:"#94a3b8",fontSize:11,marginTop:2}},props.subtitle):null
      ),
      React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8}},
        React.createElement(LangToggle,{lang:lang,setLang:setLang}),
        React.createElement("div",{style:{textAlign:"right"}},
          React.createElement("div",{style:{fontSize:11,color:"white",fontWeight:600}},currentUser.name),
          React.createElement("div",{style:{fontSize:10,color:"#64748b"}},currentUser.role==="dispatcher"?t.dispatcher:t.driver)
        ),
        React.createElement("button",{onClick:handleLogout,style:{background:"#334155",border:"none",color:"#94a3b8",padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer"}},"🚪 "+t.logout)
      )
    );
  }

  // LOGIN
  if (!currentUser) {
    return React.createElement("div",{style:{minHeight:"100vh",background:"linear-gradient(135deg,#1e3a5f 0%,#0f172a 100%)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"system-ui,sans-serif"}},
      React.createElement("div",{style:{width:"100%",maxWidth:360,padding:"0 24px"}},
        React.createElement("div",{style:{display:"flex",justifyContent:"flex-end",marginBottom:12}},React.createElement(LangToggle,{lang:lang,setLang:setLang})),
        React.createElement("div",{style:{textAlign:"center",marginBottom:32}},
          React.createElement("div",{style:{fontSize:52,marginBottom:8}},"🚛"),
          React.createElement("h1",{style:{fontSize:28,fontWeight:800,color:"white",margin:"0 0 4px"}},t.appName),
          React.createElement("p",{style:{color:"#64748b",margin:0,fontSize:14}},t.signIn)
        ),
        React.createElement("div",{style:{background:"#1e293b",borderRadius:16,padding:24,border:"1px solid #334155"}},
          loginError?React.createElement("div",{style:{background:"#ef444422",border:"1px solid #ef4444",color:"#ef4444",borderRadius:8,padding:"10px 14px",fontSize:13,marginBottom:16}},"🔒 "+loginError):null,
          React.createElement("div",{style:{marginBottom:16}},
            React.createElement("label",{style:{fontSize:12,color:"#94a3b8",display:"block",marginBottom:6,fontWeight:600}},t.username),
            React.createElement("input",{value:loginForm.username,onChange:function(e){setLoginForm({username:e.target.value,password:loginForm.password});},onKeyDown:function(e){if(e.key==="Enter")handleLogin();},placeholder:t.enterUser,style:{width:"100%",background:"#0f172a",border:"1px solid #334155",borderRadius:10,padding:"12px 14px",color:"white",fontSize:14,boxSizing:"border-box"}})
          ),
          React.createElement("div",{style:{marginBottom:24}},
            React.createElement("label",{style:{fontSize:12,color:"#94a3b8",display:"block",marginBottom:6,fontWeight:600}},t.password),
            React.createElement("div",{style:{position:"relative"}},
              React.createElement("input",{type:showPassword?"text":"password",value:loginForm.password,onChange:function(e){setLoginForm({username:loginForm.username,password:e.target.value});},onKeyDown:function(e){if(e.key==="Enter")handleLogin();},placeholder:t.enterPass,style:{width:"100%",background:"#0f172a",border:"1px solid #334155",borderRadius:10,padding:"12px 44px 12px 14px",color:"white",fontSize:14,boxSizing:"border-box"}}),
              React.createElement("button",{onClick:function(){setShowPassword(!showPassword);},style:{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"#64748b",cursor:"pointer",fontSize:16}},showPassword?"🙈":"👁")
            )
          ),
          React.createElement("button",{onClick:handleLogin,disabled:loading,style:{width:"100%",background:"#f59e0b",border:"none",color:"#0f172a",padding:"14px",borderRadius:10,fontWeight:800,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}},loading?t.loading:t.signInBtn)
        )
      )
    );
  }

  // DISPATCHER
  if (currentUser.role==="dispatcher") {
    var chatKey=chatWith?"driver-"+chatWith:null;
    var chatMsgs=chatKey?(messages[chatKey]||[]):[];
    var broadcasts=messages["broadcast"]||[];
    var lastBC=broadcasts.length>0?broadcasts[0]:null;
    var dispTabs=[
      {id:"dashboard",icon:"📊",label:t.dashboard},
      {id:"jobs",icon:"📋",label:t.jobs},
      {id:"drivers",icon:"👥",label:t.drivers},
      {id:"messages",icon:"💬",label:t.messages},
      {id:"broadcast",icon:"📣",label:t.broadcast}
    ];

    function BroadcastPanel() {
      var biSt=useState(""); var broadcastInput=biSt[0]; var setBroadcastInput=biSt[1];
      var broadcastList=messages["broadcast"]||[];
      function sendBroadcast() {
        if (!broadcastInput.trim()) return;
        addDoc(collection(db,"broadcasts"),{from:"dispatcher",text:broadcastInput,time:new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}),createdAt:serverTimestamp()});
        setBroadcastInput("");
        notify(t.broadcastSent+drivers.length+t.broadcastSentEnd);
      }
      return React.createElement("div",null,
        React.createElement("h2",{style:{fontSize:18,marginBottom:4}},"📣 "+t.broadcastTitle),
        React.createElement("p",{style:{fontSize:13,color:"#64748b",marginBottom:16}},t.broadcastSubtitle),
        React.createElement("div",{style:{background:"#1e293b",borderRadius:12,padding:16,marginBottom:16,border:"1px solid #f59e0b44"}},
          React.createElement("div",{style:{display:"flex",gap:8,marginBottom:8,flexWrap:"wrap"}},
            drivers.map(function(d){return React.createElement("span",{key:d.uid,style:{background:"#22c55e22",color:"#22c55e",border:"1px solid #22c55e44",borderRadius:20,padding:"3px 10px",fontSize:11,fontWeight:600}},"✓ "+d.name);})
          ),
          React.createElement("div",{style:{fontSize:12,color:"#64748b"}},drivers.length+" "+t.willReceive)
        ),
        React.createElement("textarea",{value:broadcastInput,onChange:function(e){setBroadcastInput(e.target.value);},placeholder:t.broadcastPlaceholder,rows:4,style:{width:"100%",background:"#1e293b",border:"1px solid #334155",borderRadius:10,padding:"12px 14px",color:"white",fontSize:13,boxSizing:"border-box",resize:"vertical",fontFamily:"system-ui,sans-serif"}}),
        React.createElement("button",{onClick:sendBroadcast,style:{width:"100%",marginTop:8,background:"#f59e0b",border:"none",color:"#0f172a",padding:"13px",borderRadius:10,fontWeight:800,fontSize:14,cursor:"pointer",marginBottom:20}},"📣 "+t.sendAll),
        broadcastList.length>0?React.createElement("div",null,
          React.createElement("h3",{style:{fontSize:13,color:"#94a3b8",textTransform:"uppercase",letterSpacing:1,marginBottom:12}},t.broadcastHistory),
          broadcastList.map(function(b,i){
            return React.createElement("div",{key:i,style:{background:"#1e293b",borderRadius:10,padding:14,marginBottom:10,border:"1px solid #f59e0b33"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",marginBottom:6}},React.createElement("span",{style:{fontSize:12,color:"#f59e0b",fontWeight:700}},"📣 "+t.allDrivers),React.createElement("span",{style:{fontSize:11,color:"#64748b"}},b.time)),
              React.createElement("div",{style:{fontSize:13,color:"white"}},b.text)
            );
          })
        ):null
      );
    }

    return React.createElement("div",{style:pageStyle},
      React.createElement(AppHeader,{subtitle:jobs.filter(function(j){return j.status!=="Delivered";}).length+t.activeJobsLabel+drivers.length+t.driversAvail}),
      React.createElement(NavBar,{tabs:dispTabs}),
      React.createElement(NotifBar,null),
      React.createElement("div",{style:{padding:16}},

        activeTab==="broadcast"?React.createElement(BroadcastPanel,null):null,

        activeTab==="dashboard"?React.createElement("div",null,
          React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:12,marginBottom:20}},
            [{label:t.totalJobs,value:jobs.length,icon:"📋",color:"#3b82f6"},{label:t.activeJobs,value:jobs.filter(function(j){return !["Delivered","Pending"].includes(j.status);}).length,icon:"🔄",color:"#f59e0b"},{label:t.delivered,value:jobs.filter(function(j){return j.status==="Delivered";}).length,icon:"✅",color:"#22c55e"},{label:t.availableDrivers,value:drivers.length,icon:"🧑‍✈️",color:"#8b5cf6"}].map(function(card){
              return React.createElement("div",{key:card.label,style:{background:"#1e293b",borderRadius:12,padding:16,border:"1px solid "+card.color+"33"}},
                React.createElement("div",{style:{fontSize:24}},card.icon),
                React.createElement("div",{style:{fontSize:28,fontWeight:800,color:card.color}},card.value),
                React.createElement("div",{style:{fontSize:12,color:"#94a3b8"}},card.label)
              );
            })
          ),
          React.createElement("h3",{style:{color:"#94a3b8",fontSize:13,textTransform:"uppercase",letterSpacing:1,marginBottom:12}},t.recentJobs),
          jobs.slice(0,3).map(function(job){
            return React.createElement("div",{key:job.id,style:{background:"#1e293b",borderRadius:10,padding:14,marginBottom:10,border:"1px solid #334155"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}},React.createElement("span",{style:{fontWeight:700}},job.title),React.createElement(Badge,{label:job.status,color:STATUS_COLORS[job.status]||"#6b7280"})),
              React.createElement("div",{style:{fontSize:12,color:"#64748b"}},t.driver+": "+job.driverName+" · "+job.createdAtDisplay)
            );
          })
        ):null,

        activeTab==="jobs"?React.createElement("div",null,
          React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}},
            React.createElement("h2",{style:{margin:0,fontSize:18}},t.allJobs),
            React.createElement("button",{onClick:function(){setShowJobForm(!showJobForm);},style:{background:"#f59e0b",border:"none",color:"#0f172a",padding:"8px 16px",borderRadius:8,fontWeight:700,cursor:"pointer",fontSize:13}},t.newJob)
          ),
          showJobForm?React.createElement("div",{style:{background:"#1e293b",borderRadius:12,padding:16,marginBottom:16,border:"1px solid #334155"}},
            React.createElement("h3",{style:{margin:"0 0 14px",fontSize:15}},t.createJob),
            [{label:t.jobTitle,key:"title",ph:"e.g. Lumber Delivery"},{label:t.pickupAddr,key:"pickup",ph:"Full address"},{label:t.deliveryAddr,key:"delivery",ph:"Full address"},{label:t.notes,key:"notes",ph:"..."}].map(function(f){
              return React.createElement("div",{key:f.key,style:{marginBottom:10}},
                React.createElement("label",{style:{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}},f.label),
                React.createElement("input",{value:newJob[f.key],onChange:function(e){var v=e.target.value;setNewJob(function(p){var u=Object.assign({},p);u[f.key]=v;return u;});},placeholder:f.ph,style:{width:"100%",background:"#0f172a",border:"1px solid #334155",borderRadius:8,padding:"8px 10px",color:"white",fontSize:13,boxSizing:"border-box"}})
              );
            }),
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}},
              React.createElement("div",null,
                React.createElement("label",{style:{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}},t.priority),
                React.createElement("select",{value:newJob.priority,onChange:function(e){var v=e.target.value;setNewJob(function(p){return Object.assign({},p,{priority:v});});},style:{width:"100%",background:"#0f172a",border:"1px solid #334155",borderRadius:8,padding:"8px 10px",color:"white",fontSize:13}},
                  ["High","Normal","Low"].map(function(p){return React.createElement("option",{key:p,value:p},priLabel(p));})
                )
              ),
              React.createElement("div",null,
                React.createElement("label",{style:{fontSize:12,color:"#94a3b8",display:"block",marginBottom:4}},t.assignDriver),
                React.createElement("select",{value:newJob.driverId,onChange:function(e){var v=e.target.value;setNewJob(function(p){return Object.assign({},p,{driverId:v});});},style:{width:"100%",background:"#0f172a",border:"1px solid #334155",borderRadius:8,padding:"8px 10px",color:"white",fontSize:13}},
                  React.createElement("option",{value:""},t.unassigned),
                  drivers.map(function(d){return React.createElement("option",{key:d.uid,value:d.uid},d.name);})
                )
              )
            ),
            React.createElement("div",{style:{display:"flex",gap:8}},
              React.createElement("button",{onClick:createJob,style:{flex:1,background:"#f59e0b",border:"none",color:"#0f172a",padding:"10px",borderRadius:8,fontWeight:700,cursor:"pointer"}},t.createJobBtn),
              React.createElement("button",{onClick:function(){setShowJobForm(false);},style:{flex:1,background:"#334155",border:"none",color:"white",padding:"10px",borderRadius:8,cursor:"pointer"}},t.cancel)
            )
          ):null,
          jobs.length===0?React.createElement("div",{style:{textAlign:"center",color:"#64748b",marginTop:60}},React.createElement("div",{style:{fontSize:40,marginBottom:12}},"📋"),React.createElement("div",{style:{fontWeight:600}},"No jobs yet. Create your first job!")):null,
          jobs.map(function(job){
            return React.createElement("div",{key:job.id,style:{background:"#1e293b",borderRadius:12,padding:16,marginBottom:12,border:"1px solid #334155"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}},
                React.createElement("div",null,React.createElement("div",{style:{fontWeight:700,fontSize:15}},job.title),React.createElement("div",{style:{fontSize:12,color:"#64748b",marginTop:2}},job.createdAtDisplay)),
                React.createElement("div",{style:{display:"flex",gap:6}},React.createElement(Badge,{label:priLabel(job.priority),color:PRI_COLORS[job.priority]}),React.createElement(Badge,{label:job.status,color:STATUS_COLORS[job.status]||"#6b7280"}))
              ),
              React.createElement("div",{style:{fontSize:13,color:"#94a3b8",marginBottom:4}},"📦 ",React.createElement("b",null,t.pickup+": "),job.pickup),
              React.createElement("div",{style:{fontSize:13,color:"#94a3b8",marginBottom:4}},"📍 ",React.createElement("b",null,t.delivery+": "),job.delivery),
              job.notes?React.createElement("div",{style:{fontSize:13,color:"#64748b",marginBottom:4}},"📝 "+job.notes):null,
              React.createElement("div",{style:{fontSize:13,color:"#94a3b8",marginBottom:10}},"🧑‍✈️ ",React.createElement("b",null,t.driver+": "),job.driverName||t.unassigned),
              React.createElement("div",{style:{display:"flex",gap:6,flexWrap:"wrap"}},
                React.createElement("a",{href:gmapsRoute(job.pickup,job.delivery),target:"_blank",rel:"noreferrer",style:{background:"#1d4ed8",color:"white",padding:"6px 12px",borderRadius:6,fontSize:12,textDecoration:"none",fontWeight:600}},"🗺 "+t.viewRoute),
                job.status!=="Delivered"?React.createElement("select",{onChange:function(e){updateJobStatus(job.id,e.target.value);},value:job.status,style:{background:"#334155",border:"none",color:"white",padding:"6px 10px",borderRadius:6,fontSize:12,cursor:"pointer"}},
                  ["Pending","Assigned","In Transit","Picked Up","Delivered"].map(function(s){return React.createElement("option",{key:s,value:s},s);})
                ):null
              )
            );
          })
        ):null,

        activeTab==="drivers"?React.createElement("div",null,
          React.createElement("h2",{style:{fontSize:18,marginBottom:16}},t.driverOverview),
          drivers.length===0?React.createElement("div",{style:{textAlign:"center",color:"#64748b",marginTop:60}},React.createElement("div",{style:{fontSize:40,marginBottom:12}},"👥"),React.createElement("div",{style:{fontWeight:600}},"No drivers yet. Add drivers in Firebase.")):null,
          drivers.map(function(d){
            var dJobs=getDriverJobs(d.uid).filter(function(j){return j.status!=="Delivered";});
            return React.createElement("div",{key:d.uid,style:{background:"#1e293b",borderRadius:12,padding:16,marginBottom:12,border:"1px solid #334155"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}},
                React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
                  React.createElement("div",{style:{width:40,height:40,borderRadius:"50%",background:"#334155",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}},"🧑‍✈️"),
                  React.createElement("div",null,React.createElement("div",{style:{fontWeight:700}},d.name),React.createElement("div",{style:{fontSize:12,color:"#64748b"}},d.email))
                ),
                React.createElement(Badge,{label:dJobs.length>0?t.onJob:t.available,color:dJobs.length>0?"#f59e0b":"#22c55e"})
              ),
              dJobs.length>0?React.createElement("div",{style:{background:"#0f172a",borderRadius:8,padding:10,marginBottom:8}},
                React.createElement("div",{style:{fontSize:12,color:"#94a3b8",marginBottom:4}},t.activeJob),
                React.createElement("div",{style:{fontSize:13,fontWeight:600}},dJobs[0].title),
                React.createElement("div",{style:{fontSize:11,color:"#64748b"}},dJobs[0].delivery)
              ):null,
              React.createElement("button",{onClick:function(){setActiveTab("messages");setChatWith(d.uid);},style:{background:"#1d4ed8",border:"none",color:"white",padding:"7px 14px",borderRadius:7,fontSize:12,cursor:"pointer",fontWeight:600}},"💬 "+t.message+" "+d.name.split(" ")[0])
            );
          })
        ):null,

        activeTab==="messages"?React.createElement("div",null,
          !chatWith?React.createElement("div",null,
            React.createElement("h2",{style:{fontSize:18,marginBottom:16}},t.messages),
            drivers.map(function(d){
              var lastMsg=(messages["driver-"+d.uid]||[]).slice(-1)[0];
              return React.createElement("div",{key:d.uid,onClick:function(){setChatWith(d.uid);},style:{background:"#1e293b",borderRadius:10,padding:14,marginBottom:10,border:"1px solid #334155",cursor:"pointer",display:"flex",alignItems:"center",gap:12}},
                React.createElement("div",{style:{width:40,height:40,borderRadius:"50%",background:"#334155",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}},"🧑‍✈️"),
                React.createElement("div",{style:{flex:1}},React.createElement("div",{style:{fontWeight:700}},d.name),React.createElement("div",{style:{fontSize:12,color:"#64748b"}},lastMsg?lastMsg.text:t.noMessagesYet))
              );
            })
          ):React.createElement("div",{style:{display:"flex",flexDirection:"column",height:"calc(100vh - 220px)"}},
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10,marginBottom:16}},
              React.createElement("button",{onClick:function(){setChatWith(null);},style:{background:"#334155",border:"none",color:"white",padding:"6px 12px",borderRadius:6,cursor:"pointer",fontSize:12}},t.back),
              React.createElement("span",{style:{fontWeight:700}},"💬 "+getDriverName(chatWith))
            ),
            React.createElement("div",{style:{flex:1,overflowY:"auto",marginBottom:12}},
              chatMsgs.length===0?React.createElement("div",{style:{color:"#64748b",textAlign:"center",marginTop:40,fontSize:13}},t.sendHi):null,
              chatMsgs.map(function(m,i){return React.createElement(ChatMessage,{key:i,m:m,isSelf:m.from==="dispatcher",lang:lang});}),
              React.createElement("div",{ref:chatEndRef})
            ),
            React.createElement("div",{style:{display:"flex",gap:8}},
              React.createElement("input",{value:msgInput,onChange:function(e){setMsgInput(e.target.value);},onKeyDown:function(e){if(e.key==="Enter")sendMessage("dispatcher",chatWith,msgInput);},placeholder:t.typeMessage,style:{flex:1,background:"#1e293b",border:"1px solid #334155",borderRadius:8,padding:"10px 14px",color:"white",fontSize:13}}),
              React.createElement("button",{onClick:function(){sendMessage("dispatcher",chatWith,msgInput);},style:{background:"#f59e0b",border:"none",color:"#0f172a",padding:"10px 16px",borderRadius:8,fontWeight:700,cursor:"pointer"}},t.send)
            )
          )
        ):null
      )
    );
  }

  // DRIVER
  if (currentUser.role==="driver") {
    var myJobs=getDriverJobs(currentUser.driverId);
    var driverMsgs=messages["driver-"+currentUser.driverId]||[];
    var dBroadcasts=messages["broadcast"]||[];
    var lastBC2=dBroadcasts.length>0?dBroadcasts[0]:null;
    var driverTabs=[{id:"jobs",icon:"📋",label:t.myJobs},{id:"chat",icon:"💬",label:t.chat}];

    return React.createElement("div",{style:pageStyle},
      React.createElement(AppHeader,{subtitle:""}),
      React.createElement(NavBar,{tabs:driverTabs}),
      React.createElement(NotifBar,null),
      React.createElement("div",{style:{padding:16}},

        activeTab==="jobs"?React.createElement("div",null,
          React.createElement("h2",{style:{fontSize:18,marginBottom:16}},t.myJobs),
          lastBC2?React.createElement("div",{style:{background:"#f59e0b11",border:"1px solid #f59e0b55",borderRadius:10,padding:12,marginBottom:16}},
            React.createElement("div",{style:{fontSize:11,color:"#f59e0b",fontWeight:700,marginBottom:4}},"📣 "+t.dispatchBroadcast+" · "+lastBC2.time),
            React.createElement("div",{style:{fontSize:13,color:"white"}},lastBC2.text)
          ):null,
          myJobs.length===0?React.createElement("div",{style:{textAlign:"center",color:"#64748b",marginTop:60}},
            React.createElement("div",{style:{fontSize:40,marginBottom:12}},"🟢"),
            React.createElement("div",{style:{fontWeight:600}},t.noJobsYet),
            React.createElement("div",{style:{fontSize:13,marginTop:6}},t.checkBack)
          ):null,
          myJobs.map(function(job){
            return React.createElement("div",{key:job.id,style:{background:"#1e293b",borderRadius:14,padding:18,marginBottom:16,border:"1px solid #334155"}},
              React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}},
                React.createElement("div",{style:{fontWeight:800,fontSize:17}},job.title),
                React.createElement(Badge,{label:job.status,color:STATUS_COLORS[job.status]||"#6b7280"})
              ),
              React.createElement("div",{style:{background:"#0f172a",borderRadius:10,padding:12,marginBottom:12}},
                React.createElement("div",{style:{marginBottom:8}},
                  React.createElement("div",{style:{fontSize:11,color:"#64748b",textTransform:"uppercase",letterSpacing:1,marginBottom:2}},"📦 "+t.pickup),
                  React.createElement("div",{style:{fontSize:14,fontWeight:600}},job.pickup)
                ),
                React.createElement("div",{style:{borderTop:"1px dashed #334155",paddingTop:8}},
                  React.createElement("div",{style:{fontSize:11,color:"#64748b",textTransform:"uppercase",letterSpacing:1,marginBottom:2}},"📍 "+t.delivery),
                  React.createElement("div",{style:{fontSize:14,fontWeight:600}},job.delivery)
                )
              ),
              job.notes?React.createElement("div",{style:{background:"#f59e0b11",border:"1px solid #f59e0b33",borderRadius:8,padding:10,marginBottom:12,fontSize:13,color:"#f59e0b"}},"⚠️ "+job.notes):null,
              React.createElement("a",{href:gmapsRoute(job.pickup,job.delivery),target:"_blank",rel:"noreferrer",style:{display:"block",background:"#1d4ed8",color:"white",padding:"12px",borderRadius:10,fontSize:14,textDecoration:"none",fontWeight:700,textAlign:"center",marginBottom:10}},"🗺 "+t.openRoute),
              job.status!=="Delivered"?React.createElement("div",null,
                React.createElement("div",{style:{fontSize:12,color:"#94a3b8",marginBottom:8}},t.updateStatus),
                React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap"}},
                  ["In Transit","Picked Up","Delivered"].map(function(st){
                    return React.createElement("button",{key:st,onClick:function(){updateJobStatus(job.id,st);},style:{flex:1,background:job.status===st?STATUS_COLORS[st]:"#334155",border:"none",color:"white",padding:"10px 8px",borderRadius:8,fontSize:12,cursor:"pointer",fontWeight:600,minWidth:80}},
                      st==="In Transit"?"🚛 "+t.inTransit:st==="Picked Up"?"📦 "+t.pickedUp:"✅ "+t.statusDelivered
                    );
                  })
                )
              ):React.createElement("div",{style:{textAlign:"center",color:"#22c55e",fontWeight:700,fontSize:15}},"✅ "+t.jobComplete)
            );
          })
        ):null,

        activeTab==="chat"?React.createElement("div",{style:{display:"flex",flexDirection:"column",height:"calc(100vh - 200px)"}},
          React.createElement("h2",{style:{fontSize:18,margin:"0 0 4px"}},"💬 "+t.chatTitle),
          React.createElement("p",{style:{fontSize:12,color:"#64748b",margin:"0 0 12px"}},t.chatPrivate),
          lastBC2?React.createElement("div",{style:{background:"#f59e0b11",border:"1px solid #f59e0b55",borderRadius:10,padding:12,marginBottom:12}},
            React.createElement("div",{style:{fontSize:11,color:"#f59e0b",fontWeight:700,marginBottom:4}},"📣 "+t.latestBroadcast+" · "+lastBC2.time),
            React.createElement("div",{style:{fontSize:13,color:"white"}},lastBC2.text)
          ):null,
          React.createElement("div",{style:{flex:1,overflowY:"auto",marginBottom:12}},
            driverMsgs.length===0?React.createElement("div",{style:{color:"#64748b",textAlign:"center",marginTop:40,fontSize:13}},t.sendHi):null,
            driverMsgs.map(function(m,i){return React.createElement(ChatMessage,{key:i,m:m,isSelf:m.from==="driver",lang:lang});}),
            React.createElement("div",{ref:chatEndRef})
          ),
          React.createElement("div",{style:{display:"flex",gap:8}},
            React.createElement("input",{value:msgInput,onChange:function(e){setMsgInput(e.target.value);},onKeyDown:function(e){if(e.key==="Enter")sendMessage("driver",currentUser.driverId,msgInput);},placeholder:t.messageDispatch,style:{flex:1,background:"#1e293b",border:"1px solid #334155",borderRadius:8,padding:"10px 14px",color:"white",fontSize:13}}),
            React.createElement("button",{onClick:function(){sendMessage("driver",currentUser.driverId,msgInput);},style:{background:"#f59e0b",border:"none",color:"#0f172a",padding:"10px 16px",borderRadius:8,fontWeight:700,cursor:"pointer"}},t.send)
          )
        ):null
      )
    );
  }

  return null;
}